<template>
	<div v-if="$settings.debug" :class="$style.debug">
		<div class="d-block d-sm-none">XS</div>
		<div class="d-none d-sm-block d-md-none">SM</div>
		<div class="d-none d-md-block d-lg-none">MD</div>
		<div class="d-none d-lg-block d-xl-none">LG</div>
		<div class="d-none d-xl-block d-xxl-none">XL</div>
		<div class="d-none d-xxl-block">XXL</div>
	</div>
</template>

<script>
export default {
	name: "CssDebug",
	computed: {
		development() {
			if (process.env.VUE_APP_ENVIRONMENT !== "production") return true;
			return false;
		},
	},
};
</script>

<style module>
.debug {
	position: fixed;
	top: 0px;
	right: calc(50% - 60px);
	background: rgba(0, 0, 0, 0.5);
	padding: 10px;
	margin: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	border-radius: 10px;
	font-weight: bold;
	color: white;
}
</style>
